import React from 'react';
/** @type {React.Context<StorefrontContextType | null>} */
const SessionContext = React.createContext();
export default SessionContext;
